import { DataGrid } from '@mui/x-data-grid';
import * as React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import InfoIcon from '@mui/icons-material/Info';
import { useJumboDialog } from '@jumbo/components/JumboDialog/hooks/useJumboDialog';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InfoIcon from '@mui/icons-material/Toc';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SimpleUploadDialog from './UpoadFileModal';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import Div from '@jumbo/shared/Div/Div';
const ApifyClient = require('apify-client');
const columns = [
  {
    field: 'id',
    headerName: 'ID',
    sortable: false,
    flex: 220,
    align: 'center',
    headerAlign: 'center',
    editable: true,
  },
  {
    field: 'asinNumber',
    headerName: 'ASINS For Vo',
    sortable: false,
    flex: 220,
    align: 'center',
    headerAlign: 'center',
    editable: true,
  },
];

export default function AutomatedVO() {

  const [rows, setRows] = React.useState([]);
  const { hideDialog, showDialog } = useJumboDialog();
  const navigate = useNavigate();

  const onAsinBulkUpload = (fileData) => {
    // //console.log("onAsinBulkUpload---", fileData);
    let updatedRows = [...rows, fileData]
    setRows(updatedRows[0])
    hideDialog();
  }

  const showAddFileDialog = React.useCallback(() => {
    showDialog({
      title: "Add File",
      content: <SimpleUploadDialog onChangeValue={(fileData) => onAsinBulkUpload(fileData)} />
    });
  }, [showDialog]);
  const Swal = useSwalWrapper();
  const sweetAlerts = (message) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  };
  const onGetInformationClick = () => {
    // //console.log("onGetInformationClick---",rows);
    if (rows.length > 0) {
      navigate('/automated-vo/details', { state: rows })
    } else {
      sweetAlerts('Please Enter Some Asin Numbers')
    }
  }
  return (
    <React.Fragment>
      <Div style={{ width: '100%' }}>
        <Button style={{ marginBottom: 5 }} sx={{ float: 'right' }} startIcon={<FileDownloadIcon />}
          variant="contained" href="/images/automatedVo.csv">
          sample Csv
        </Button>
        <Button style={{ marginBottom: 5 }} sx={{ float: 'right', marginRight: 1 }} startIcon={<UploadFileIcon />}
          variant="contained" onClick={showAddFileDialog}>
          Bulk Upload Csv
        </Button>
        <Button style={{ marginBottom: 5 }} sx={{ float: 'right', marginRight: 1 }} startIcon={<InfoIcon />}
          variant="contained" onClick={onGetInformationClick}>
          Get Info.
        </Button>
      </Div>
      <div style={{ height: '100%', width: '100%' }}>
        <DataGrid
          sx={{
            // display: 'flex',
            // alignItems: 'center',
            mb: 5,
            backgroundColor: '#ffffff',
            boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px;'
          }}
          pageSize={10}
          autoPageSize={true}
          autoHeight={true}
          density='standard'
          filterMode='server'
          // hideFooter={true}
          rows={[...rows]}
          columns={[...columns]} />
      </div>
    </React.Fragment>
  );
}